// Public landing-page intent; no patient details or behavioral audiences.
export const EXPANDED_LANDING_PAGES = {
  "/all-on-x": {
    "label": "Full-arch dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed full-arch teeth with doctor-led planning, an in-house lab and a written treatment plan.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/all-on-4-vs-dentures": {
    "label": "All-on-4 vs dentures",
    "intent": "implant",
    "color": "brand",
    "summary": "Compare fixed implant teeth and removable dentures around eating, stability, maintenance and cost.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/all-on-4-vs-all-on-6": {
    "label": "All-on-4 vs All-on-6",
    "intent": "implant",
    "color": "brand",
    "summary": "Understand four-implant and six-implant plans and the clinical assessment that guides the choice.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/fixed-vs-removable-implant-teeth": {
    "label": "Fixed vs removable implant teeth",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore daily use, cleaning, maintenance and cost with an individual assessment.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-questions": {
    "label": "Dental implant questions",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore the decisions behind implant care, then discuss your goals, suitability and next steps with Dr. Gjelaj.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/implant-research-data": {
    "label": "Implant research and evidence",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore dental implant research and what study findings can—and cannot—tell you about an individual treatment plan.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/all-on-4-guide": {
    "label": "All-on-4 patient guide",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore All-on-4 treatment stages, practical considerations and questions to bring to a consultation.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/cosmetic-dentistry-guide": {
    "label": "Cosmetic dentistry guide",
    "intent": "consult",
    "color": "brand",
    "summary": "Explore veneers, whitening and smile design. Start with your goals; an examination determines the appropriate treatment.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implant-cost-florida": {
    "label": "Dental implant cost in Florida",
    "intent": "implant",
    "color": "brand",
    "summary": "Compare what an implant treatment quote includes, potential additional costs and payment questions before deciding.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/does-medicare-cover-dental-implants": {
    "label": "Dental implants and Medicare",
    "intent": "implant",
    "color": "brand",
    "summary": "Review the coverage questions to ask your insurer and dental team. Confirm benefits and your written treatment estimate before committing.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-vs-dentures": {
    "label": "Dental implants vs dentures",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore how fixed implant teeth and removable dentures differ in daily use, maintenance and cost.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/do-dental-implants-hurt": {
    "label": "Implant comfort and recovery",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore the stages of implant care and the questions to ask about comfort, recovery and follow-up.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/too-old-for-dental-implants": {
    "label": "Implant candidacy and age",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss your priorities and health with a dentist. An individual assessment guides whether implant treatment is appropriate.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/how-to-choose-a-dentist-in-trinity-fl": {
    "label": "Choosing a dentist in Trinity",
    "intent": "call",
    "color": "brand",
    "summary": "Compare the experience, communication and visit planning that matter to you when choosing a dentist.",
    "steps": [
      "Call our team about the appropriate appointment",
      "Confirm availability, preparation and visit fees",
      "Meet with the dental team for an individual assessment"
    ]
  },
  "/loose-dentures-trinity-fl": {
    "label": "Denture concerns",
    "intent": "implant",
    "color": "brand",
    "summary": "Talk about eating, comfort and your smile goals. An examination helps identify an appropriate path forward.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/cant-chew-missing-teeth": {
    "label": "Eating and missing teeth",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss how missing or failing teeth affect your daily life and explore options with an individual treatment plan.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/afraid-of-dental-work-sedation": {
    "label": "Comfort and sedation options",
    "intent": "call",
    "color": "brand",
    "summary": "Tell our team what has made dental visits difficult. Ask about an appointment and comfort options suited to your needs.",
    "steps": [
      "Call our team about the appropriate appointment",
      "Confirm availability, preparation and visit fees",
      "Meet with the dental team for an individual assessment"
    ]
  },
  "/same-day-dental-implants-trinity-fl": {
    "label": "Same-day implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss full-arch treatment, temporary teeth and the steps toward your final restoration. Timing depends on clinical suitability.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/sleep-apnea-treatment": {
    "label": "Sleep apnea dental care",
    "intent": "call",
    "color": "brand",
    "summary": "Ask about dental oral-appliance evaluation, suitability and coordination with your sleep-care team.",
    "steps": [
      "Call our team about the appropriate appointment",
      "Confirm availability, preparation and visit fees",
      "Meet with the dental team for an individual assessment"
    ]
  },
  "/tmj-treatment": {
    "label": "Jaw pain and TMJ evaluation",
    "intent": "call",
    "color": "brand",
    "summary": "Talk with our team about a jaw-pain or TMJ evaluation and the appropriate appointment for your needs.",
    "steps": [
      "Call our team about the appropriate appointment",
      "Confirm availability, preparation and visit fees",
      "Meet with the dental team for an individual assessment"
    ]
  },
  "/emergency-dentist-trinity-fl": {
    "label": "Urgent dental care",
    "intent": "urgent",
    "color": "brand",
    "summary": "Call our Trinity team during office hours to discuss the next available urgent visit. Confirm availability before traveling.",
    "steps": [
      "Call Monday–Thursday, 9am–5pm",
      "Discuss the next available urgent visit",
      "Confirm availability before traveling"
    ]
  },
  "/emergency-dentist-new-port-richey-fl": {
    "label": "Urgent dental care",
    "intent": "urgent",
    "color": "brand",
    "summary": "For an urgent dental concern, call our Trinity office to discuss availability before traveling from New Port Richey.",
    "steps": [
      "Call Monday–Thursday, 9am–5pm",
      "Discuss the next available urgent visit",
      "Confirm availability before traveling"
    ]
  },
  "/family-dentist-trinity-fl": {
    "label": "Family dentistry",
    "intent": "call",
    "color": "brand",
    "summary": "Explore exams, cleanings and preventive care. Call our Trinity team to arrange the appropriate visit.",
    "steps": [
      "Call our team about the appropriate appointment",
      "Confirm availability, preparation and visit fees",
      "Meet with the dental team for an individual assessment"
    ]
  },
  "/cosmetic-dentist-trinity-fl": {
    "label": "Cosmetic dentistry",
    "intent": "consult",
    "color": "brand",
    "summary": "Start with your smile goals. Explore veneers, whitening and smile design with an individual treatment plan.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/veneers-trinity-fl": {
    "label": "Porcelain veneers",
    "intent": "consult",
    "color": "brand",
    "summary": "Explore porcelain veneers, shade and shape with our Trinity team. An examination helps determine the right approach to your smile goals.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/teeth-whitening-trinity-fl": {
    "label": "Professional whitening",
    "intent": "call",
    "color": "brand",
    "summary": "Discuss professional whitening and your shade goals with our Trinity team. Call to confirm the appropriate appointment, availability and fees.",
    "steps": [
      "Call our team about the appropriate appointment",
      "Confirm availability, preparation and visit fees",
      "Meet with the dental team for an individual assessment"
    ]
  },
  "/invisalign-new-port-richey-fl": {
    "label": "Invisalign®",
    "intent": "consult",
    "color": "brand",
    "summary": "Explore Invisalign and doctor-led planning at our Trinity office. Start with your goals and an individual assessment.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/trinity-fl": {
    "label": "Dental care",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore dental care, implant options and smile planning at 11105 Trinity Blvd. Our team can help arrange the right visit.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/tampa-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Tampa residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/clearwater-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Clearwater residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/new-port-richey-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome New Port Richey residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dentist-seven-springs-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Seven Springs residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/best-implant-dentist-trinity-fl": {
    "label": "Choosing implant care",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore Dr. Gjelaj’s approach to implant planning, the in-house lab and questions to ask before choosing care.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/st-petersburg-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome St. Petersburg residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/palm-harbor-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Palm Harbor residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-trinity-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore single-tooth and full-arch options with Dr. Gjelaj and our Trinity team. Begin with your priorities and an individual assessment.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/cosmetic-dentist-tampa-fl": {
    "label": "Cosmetic dentistry",
    "intent": "consult",
    "color": "brand",
    "summary": "Explore veneers, whitening and smile design at our Trinity office. We welcome Tampa residents for individual smile planning.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/all-on-4-new-port-richey-fl": {
    "label": "All-on-4",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss full-arch implant options and treatment stages at our Trinity office. We welcome New Port Richey residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-new-port-richey-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss single-tooth and full-arch implant care at our Trinity office, with a written plan guided by your examination.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/all-on-4-trinity-fl": {
    "label": "All-on-4",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss full-arch implant care, temporary and final teeth, and the stages of your individual treatment plan.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/emergency-dentist-clearwater-fl": {
    "label": "Urgent dental care",
    "intent": "urgent",
    "color": "brand",
    "summary": "For an urgent dental concern, call our Trinity office to discuss availability before traveling from Clearwater.",
    "steps": [
      "Call Monday–Thursday, 9am–5pm",
      "Discuss the next available urgent visit",
      "Confirm availability before traveling"
    ]
  },
  "/veneers-palm-harbor-fl": {
    "label": "Porcelain veneers",
    "intent": "consult",
    "color": "brand",
    "summary": "Explore veneers, shade and shape with our team at the Trinity office. We welcome Palm Harbor residents for smile planning.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/invisalign-trinity-fl": {
    "label": "Invisalign®",
    "intent": "consult",
    "color": "brand",
    "summary": "Explore Invisalign with doctor-led planning. An assessment guides suitability, treatment planning and your next step.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-near-trinity-college-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss single-tooth and full-arch implant care at 11105 Trinity Blvd. We welcome Trinity College area residents and plan care around an individual examination.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-near-trinity-commons-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss single-tooth and full-arch implant care at 11105 Trinity Blvd. We welcome Trinity Commons residents and plan care around an individual examination.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-trinity-east-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss single-tooth and full-arch implant care at 11105 Trinity Blvd. We welcome Trinity East residents and plan care around an individual examination.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-trinity-west-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss single-tooth and full-arch implant care at 11105 Trinity Blvd. We welcome Trinity West residents and plan care around an individual examination.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dental-implants-trinity-preserve-fl": {
    "label": "Dental implants",
    "intent": "implant",
    "color": "brand",
    "summary": "Discuss single-tooth and full-arch implant care at 11105 Trinity Blvd. We welcome Trinity Preserve residents and plan care around an individual examination.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/spring-hill-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Spring Hill residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/hudson-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Hudson residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/brooksville-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Brooksville residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/holiday-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Holiday residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/tarpon-springs-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Tarpon Springs residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/dunedin-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Dunedin residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/zephyrhills-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Zephyrhills residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/port-richey-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Port Richey residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/odessa-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Odessa residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/keystone-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Keystone residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/wesley-chapel-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Wesley Chapel residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/land-o-lakes-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Land O' Lakes residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/lutz-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Lutz residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/westchase-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Westchase residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  },
  "/oldsmar-fl": {
    "label": "Dental implant planning",
    "intent": "implant",
    "color": "brand",
    "summary": "Explore fixed-tooth options, treatment stages and visit planning with Dr. Xhoana Gjelaj. Care takes place at our Trinity office; we welcome Oldsmar residents.",
    "steps": [
      "Request your preferred consultation time",
      "Our team confirms availability and arranges $300 prepayment",
      "Review your options and written plan; begin treatment within 30 days to apply the consultation credit"
    ]
  }
};

